export class Recurrence {
  id: number = -1;
  startDate: string = '';
  endDate: string = '';
  timeValue: number = 1;
  timeUnit: string ='d'
  recurrenceType:string = '';
  recurrenceParentId: number = -1;
  recurrenceAmount: number = 0;
  recurrenceWeekDays: string = '';
  recurrenceDayNo: number = -1;
  recurrenceWeekno: number = -1;
  recurrenceMonthno: number = -1;
  createdBy: number = -1;
  createdAt: string = '';
  updatedAt: string = '';
}
